<template>
    <div
        class="max-w-[1145px] px-[15px] w-full mx-auto mt-[6.75em]"
    >
        <div class="relative rounded-[15px] mt-[-63px] bg-white">
            <div class="w-full text-sm text-left rtl:text-right text-gray-500 rounded-[15px]">
                <div class="border-b border-[#eeeff2] px-6 py-3 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white">
                    <div class="flex items-center md:justify-between flex-col md:flex-row">

                        <div class="mb-[1.5rem] md:mb-[-1.5rem] font-[CircularBold]">
                            <a
                                v-for="(btn, index) in sections"
                                :key="index"
                                @click="activeSection = index"
                                class="text-[20px] p-[0.5rem] md:p-4 font-[CircularBook] text-center cursor-pointer"
                                :class="{ 'text-[#366fed]': activeSection === index }"
                                id="alts-pairs-tab"
                                type="button"
                            >
                              {{btn}}
                            </a>
                        </div>

                        <div class="max-w-[355px] w-full">
                            <div class="flex">
                                <div class="flex w-full">
                                    <input
                                        v-model="searchPair"
                                        type="search"
                                        id="location-search"
                                        class="block px-2.5 py-2 w-[calc(100%-40px)] text-sm text-gray-900 border border-[#eeeff2] bg-white rounded-lg !border-r-0 !rounded-tr-none !rounded-br-none"
                                        placeholder="Search"
                                    />
                                    <button type="submit" class="p-2.5 text-sm font-medium text-white border border-[#eeeff2] !border-l-0 !rounded-tl-none !rounded-bl-none rounded-lg">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m19.388 18.22-3.835-3.841a8.715 8.715 0 0 0 2.058-5.629C17.61 3.925 13.693 0 8.877 0 4.06 0 .142 3.925.142 8.75S4.06 17.5 8.877 17.5a8.68 8.68 0 0 0 5.618-2.061l3.835 3.841a.746.746 0 0 0 1.058 0 .75.75 0 0 0 0-1.06zM1.64 8.75c0-3.998 3.246-7.25 7.237-7.25 3.99 0 7.236 3.252 7.236 7.25S12.867 16 8.877 16C4.886 16 1.64 12.748 1.64 8.75z" fill="#A4A6AA"/>
                                        </svg>
                                        <span class="sr-only">Search</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="overflow-x-auto">
                <div
                    v-for="(pair, index) in sections"
                    v-show="activeSection === index"
                    :key="pair"
                    class=""
                    :class="pair === 'BTC' ? 'active' : ''"
                    :id="`${pair.toLowerCase()}-pairs`"
                    role="tabpanel"
                    :aria-labelledby="`${pair.toLowerCase()}-pairs-tab`"
                >
                    <table class="w-full text-sm text-left rtl:text-right text-gray-500 rounded-[15px] mb-[4.2em]">
                        <thead class="text-xs text-gray-700 uppercase bg-white">
                            <tr>
                                <th scope="col" class="px-6 py-3">
                                    <button class="flex items-center gap-2">
                                        <span class="block text-[#2a395a] text-[14px]">Market</span>
<!--                                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                                    </button>
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    <button class="flex items-center gap-2">
                                        <span class="block text-[#2a395a] text-[14px]">Currency</span>
<!--                                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                                    </button>
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    <button class="flex items-center gap-2">
                                        <span class="block text-[#2a395a] text-[14px]">Last Price</span>
<!--                                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                                    </button>
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    <button class="flex items-center gap-2">
                                        <span class="block text-[#2a395a] text-[14px]">Change</span>
<!--                                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                                    </button>
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    <button class="flex items-center gap-2">
                                        <span class="block text-[#2a395a] text-[14px]">Volume</span>
<!--                                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                                    </button>
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    <button class="flex items-center gap-2">
                                        <span class="block text-[#2a395a] text-[14px]">24 High</span>
<!--                                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                                    </button>
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    <button class="flex items-center gap-2">
                                        <span class="block text-[#2a395a] text-[14px]">24 Low</span>
<!--                                        <img src="@/../img/icons/sort-arrows.svg" alt="">-->
                                    </button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                class="bg-white text-[12px] text-[#170f34]"
                                v-for="market in filteredPairs(pair)"
                                :key="market.id"
                            >
                                <td class="px-6 py-1">
                                    <a :href="`/exchange/` + market.title">{{ market.title_formatted }}</a>
                                </td>
                                <td class="px-6 py-1 text-[#a4a6aa]">
                                    {{ market.currency }}
                                </td>
                                <td class="px-6 py-1">
                                    {{ parseFloat(market.last_price).toFixed(market.price_decimals) }}
                                </td>
                                <td class="px-6 py-1">
                                    <span
                                        class="block w-fit text-white text-[12px] font-[600] rounded-[5px] px-[.38em] py-[.17em]"
                                        :class="market.change_day >= 0 ? 'bg-[#58bd7d]' : 'bg-[#cf3d3d]'"
                                    >
                                        {{ market.change_day }}%
                                    </span>
                                </td>
                                <td class="px-6 py-1">
                                    {{ parseFloat(market.quote_volume_day).toFixed(market.price_decimals) }}
                                </td>
                                <td class="px-6 py-1">
                                    {{ parseFloat(market.high_day).toFixed(market.price_decimals) }}
                                </td>
                                <td class="px-6 py-1">
                                    {{ parseFloat(market.low_day).toFixed(market.price_decimals) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import {backendSocket} from "../../sockets";
const pairs = ref(window.pairs);
const searchPair = ref("")
const activeSection = ref(1);
const sections = ['BTC', 'USDT', 'ALTS'];

const filteredPairs = (pair) => {
    return pairs.value[pair]?.filter((market) => market.title_formatted.includes(searchPair.value.toUpperCase()))
}

onMounted(() => {
    backendSocket.channel('market.public').listen('.market_data.updated', ({marketData}) => {

        const foundIndex = pairs.value[marketData.tab].findIndex((el) => el.id === marketData.id)

        const newPairs = pairs.value;
        newPairs[marketData.tab][foundIndex] = marketData;

        pairs.value = newPairs;
    });
})
</script>
